export default __webpack_public_path__ + "static/media/19.f4708bf5.png";